import { CSSProperties, useEffect, useRef } from "react";

// THIS IS NOT MINE, THIS IS FROM : https://ibelick.com/blog/create-animated-gradient-borders-with-css

interface AnimatedBorderProps {
  children: React.ReactNode;
  index: number;
}


export function AnimatedBorder({children, index=0}:AnimatedBorderProps){
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const boxElement = boxRef.current;

    if (!boxElement) {
      return;
    }

    const updateAnimation = () => {
      const angle =
        (parseFloat(boxElement.style.getPropertyValue("--angle")) + 0.5) % 360;
      boxElement.style.setProperty("--angle", `${angle}deg`);
      requestAnimationFrame(updateAnimation);
    };

    requestAnimationFrame(updateAnimation);
  }, []);
  if(index == 0){
    return (
      <div
      ref={boxRef}
      style={
        {
          "--angle": "0deg",
          "--border-color": "linear-gradient(var(--angle), #070707, #c98e2e)",
          "--bg-color": "linear-gradient(#131219, #131219)",
        } as CSSProperties
      }
      className="flex items-center w-full justify-center rounded-lg border-2 border-[#0000] [background:padding-box_var(--bg-color),border-box_var(--border-color)]"
    >
      {children}
    </div>
  );
  }
  else{
    return(
      <div ref={boxRef} className="w-full">
        {children}
      </div>
    )
  }
};
